/*
* Good3Lib
*
* This lib provides procedures to handle global tasks which can be used throughout
* the entire project. Almost all the classes should add it to the mixins.
*/

// The LIBRARY
export const Good3Lib = {
  data: () => ({

  }),
  methods: {
    // humanDisplayLargeNumbers returns a string with the K, M, G, T suffixes.
    humanDisplayLargeNumbers (pAmount) {
      if (pAmount < 1000) {
        return pAmount
      } else if (pAmount < 1000000) {
        return '' + (pAmount / 1000).toFixed(1) + 'k'
      } else if (pAmount < 1000000000) {
        return '' + (pAmount / 1000000).toFixed(2) + 'M'
      } else if (pAmount < 1000000000000) {
        return '' + (pAmount / 1000000).toFixed(3) + 'G'
      } else {
        return '' + (pAmount / 1000000000000).toFixed(3) + 'T'
      }
    },

    // helpMeBackendURLForPath is helping to generate URLs to the backend.
    // The path should not start with any / but we trim it anyway.
    helpMeBackendURLForPath (pPath) {
      // stripping the pPath to remove the leading /
      var vRegEx = /^\/*/

      // returning
      return 'https://' +
        process.env.VUE_APP_GOOD3_BACK_HOSTNAME +
        '/' +
        pPath.replace(vRegEx, '')
    }
  }
}
